import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"
import "./NotesLight.scss"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgNotesLight = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 12 12"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        className="NotesLight"
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            stroke="#48484E"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M5.5 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6.5"
        />
        <path
            stroke="#48484E"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9.25 1.25a1.06 1.06 0 0 1 1.5 1.5L6 7.5 4 8l.5-2z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgNotesLight)
const Memo = memo(ForwardRef)
export default Memo
